/**
 * One account number can hold several currencies, and each is a separate
 * account with its own balance — מזרחי 9758 exists in ILS, USD and EUR at once.
 * The import keys them apart on currency for exactly that reason, so the UI has
 * to show it or three different accounts read as one repeated three times.
 *
 * Shared rather than inlined because the account appears in five places — the
 * balances table, the filter menu, the selected-account tags, the transaction
 * tables and the daily balance charts — and a label that disagrees between them
 * is worse than no label at all.
 */

/** "9758 (ILS)", falling back to the bare number when no currency is known. */
export const accountNumberWithCurrency = (lastFour, currencyCode) => {
  const number = lastFour || '-';
  const currency = (currencyCode || '').trim();

  return currency ? `${number} (${currency})` : number;
};

/** "מזרחי 9758 (ILS)" — how an account is named outside the balances table. */
export const accountLabel = (account) => {
  if (!account) {
    return '';
  }

  const bankName = account.bank_name || account.bankName || '';
  const lastFour = account.last_four || account.lastFour || '';
  const currencyCode = account.currency_code || account.currencyCode || '';

  return `${bankName} ${accountNumberWithCurrency(lastFour, currencyCode)}`.trim();
};
